import { cssToken } from "@certn/cascadia/utils";
import { CascadiaColor } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import classNames from "classnames";
import { PropsWithChildren } from "react";

import { mq } from "../utils";
interface Props {
  type?: "default" | "large";
  border?: CascadiaColor | "dropshadow" | "none";
  background?: CascadiaColor;
  className?: string;
  testID?: string;
  hideBorder?: boolean;
  /** Hides border radius and shadows on small screens */
  responsive?: boolean;
  ariaLabel?: string;
}

export function Card(props: PropsWithChildren<Props>) {
  const {
    type = "default",
    border = "border-base",
    background = "background-base",
    className,
    children,
    testID = "card",
    ariaLabel,
    hideBorder,
    responsive,
  } = props;

  return (
    <section
      aria-label={ariaLabel}
      className={classNames(
        styles.card,
        background && css({ background: cssToken(background) }),
        !hideBorder &&
          css(
            border !== "none" &&
              border !== "dropshadow" && {
                boxShadow: `inset 0 0 0 1px ${cssToken(border)}`,
              },
            border === "dropshadow" && { boxShadow: "var(--shadow-card)" }
          ),
        className
      )}
      data-type={type}
      data-responsive={responsive || undefined}
      data-testid={testID}
    >
      {children}
    </section>
  );
}

const styles = {
  card: css({
    background: "var(--background-base)",
    overflow: "hidden",
    border: "0px solid var(--border-base)",
    borderRadius: "var(--border-radius-2)",
    "&[data-type=large]": { borderRadius: "var(--border-radius-3)" },
    "&[data-border=none]": { border: "none" },
    "&[data-responsive]": css(
      mq({
        borderRadius: ["var(--border-radius-0)", "var(--border-radius-3)"],
        borderWidth: 0,
        borderRightWidth: 0,
        boxShadow: ["none", "inset 0 0 0 1px var(--border-base)"],
        borderTopWidth: ["1px", 0],
        borderBottomWidth: ["1px", 0],
      })
    ),
  }),
};
